<template>
  <Card>
    <template v-slot:content>
      <div class="p-grid">
        <div class="p-col-12">
          <h5>Bovinos cadastrados</h5>
        </div>
        <div class="p-col-12">
          <Skeleton v-if="loading" height="235px" />
          <Chart
            v-else
            ref="chart"
            type="bar"
            :data="chartData"
            :options="chartOptions"
            :width="200"
            :height="80"
          />
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
import Chart from 'primevue/chart';
import { ReportApi } from '../../../services/api';

export default {
  components: { Chart },
  data() {
    return {
      chartOptions: {
        plugins: {
          legend: { display: false },
        },
      },
      chartData: { labels: [], datasets: [] },
      loading: false,
    };
  },
  async created() {
    await this.getData();
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
        const data = await ReportApi.getBovinesByRegistration();
        this.chartData = {
          labels: [
            'Janeiro',
            'Fevereiro',
            'Março',
            'Abril',
            'Maio',
            'Junho',
            'Julho',
            'Agosto',
            'Setembro',
            'Outubro',
            'Novembro',
            'Dezembro',
          ],
          datasets: [
            {
              backgroundColor: '#7cb5ec',
              data: data.map((dataItem) => dataItem.count),
            },
          ],
        };
        if (this.$refs.chart) {
          this.$refs.chart.reinit();
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
div >>> .p-card-content {
  padding: 0;
}
</style>
